import * as React from 'react'
import { ResourcesRecordShape } from '../../api/api_data_types'
import EntryItem from './EntryItem'
import {
  new_resources_adjustment_path,
  edit_presence_day_path,
  export_to_nav_resources_record_path,
} from '../../routes'
import ExportToNavButton from './ExportToNavButton'
import EntryActions from './EntryActions'

type PresenceItemProps = {
  record: ResourcesRecordShape
}

export default function PresenceItem({ record }: PresenceItemProps) {
  const isExported = record.exported === true
  const canExport = record.can_export_to_nav === true

  return (
    <EntryItem
      jobTitle={`${record.jobnumber.order_number_title}. ${record.jobnumber.customer_title}`}
      times={record.times}
      timeColumnClassName="col"
      footer={
        <>
          {isExported && (
            <EntryActions
              actions={[
                <a
                  className="btn btn-outline-secondary"
                  href={new_resources_adjustment_path({ master_id: record.id })}
                >
                  Tilføj korrektion
                </a>,
              ]}
            />
          )}
          {!isExported && (
            <EntryActions
              columnClassName="col"
              actions={[
                <a className="btn btn-outline-secondary mr-2" href={edit_presence_day_path(record.id)}>
                  Ændre
                </a>,
                canExport ? <ExportToNavButton href={export_to_nav_resources_record_path(record.id)} /> : null,
              ].filter(Boolean) as React.ReactNode[]}
            />
          )}
        </>
      }
    />
  )
}

